<template>
  <div v-if="shouldShowPasswordRestrictions(password)">
    <span
      v-for="error in passwordValidationErrors"
      class="d-block"
      :class="{ text__error: !error.passed }"
      :key="error.error">
      {{ t(`global.errors.${camelCase(error.message)}`) }}
    </span>
  </div>
</template>

<script>
import { camelCase } from 'lodash';
import { getPasswordValidationErrors, t } from '@nova/core';

export default {
  props: {
    password: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      passwordValidationErrors: []
    };
  },
  watch: {
    password(newValue) {
      this.computePasswordRestrictions(newValue);
    }
  },
  methods: {
    t,
    camelCase,
    computePasswordRestrictions(password) {
      this.passwordValidationErrors = getPasswordValidationErrors(password);
    },
    shouldShowPasswordRestrictions(password) {
      return password.length > 0 && this.$validator.rules.password.some(x => x(password) !== true);
    }
  },
  mounted() {
    this.computePasswordRestrictions(this.password);
  }
};
</script>
